export const ColorModeDataAttribute = 'data-theme';
export const Tints = [
    100, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
];
export const Spacings = [
    0, 25, 50, 75, 100, 150, 200, 250, 300, 400, 500, 600, 800, 1000,
];
export const DEFAULT_TEXT_VALUES = {
    size: 16,
    lineHeight: 1.5,
    weight: 400,
    tracking: 1,
};
export const ColorModes = ['light', 'dark'];
export const BaseColors = ['white', 'black'];
export const PaletteColors = [
    'red',
    'green',
    'blue',
    'orange',
    'purple',
    'teal',
    'pink',
    'grey',
];
export const ThemeColors = [
    'neutral',
    'primary',
    'success',
    'warning',
];
export const ThemeColorMap = {
    neutral: 'grey',
    primary: 'blue',
    success: 'green',
    warning: 'red',
};
export const Colors = [
    ...BaseColors,
    ...PaletteColors,
    ...ThemeColors,
];
export const IconSizes = [
    'default',
    'small',
    'medium',
    'large',
    'larger',
    'largest',
];
